import type { JSX } from 'react'
import RequirePermission from '../../components/auth/RequirePermission.js'
import BudgetPanel from '../../components/admin/ai/BudgetPanel.js'

/**
 * Standalone Usage & Budget page — renders the BudgetPanel which mirrors the
 * Safety screen's versioned, scoped configuration UX.
 */
export default function AiUsagePage(): JSX.Element {
  return (
    <RequirePermission permission="admin:extensions:view">
      <BudgetPanel />
    </RequirePermission>
  )
}
